import ArrowsRightIcon from "@redotech/redo-icons/arrows-right_filled.svg";
import { Step } from "@redotech/redo-model/return-flow";
import { separateLabelsFromModel } from "@redotech/redo-model/return-flow-step-from-model";
import {
  isSeparateLabelsStepValid,
  SeparateLabelsState,
} from "@redotech/redo-model/return-flow-step-valid";
import { BlockLayout } from "@redotech/redo-web/flowchart";
import React from "react";
import { StepType, StepTypeDetailsProps } from "../step";

export const SEPARATE_LABELS = (
  Details: React.ComponentType<StepTypeDetailsProps<SeparateLabelsState>>,
): StepType<SeparateLabelsState, Step.SeparateLabels> => ({
  layout() {
    return BlockLayout.FULL;
  },
  empty: {},

  title: "Separate labels",

  customTitle: (state) => state.customTitle,

  description: () => {
    return "Items get their own label";
  },

  Icon: ArrowsRightIcon,
  iconColor: "success",

  Details(props) {
    return <Details {...props} />;
  },

  downstream: () => [],

  maxDownstream: () => 0,

  fromModel: (model) => separateLabelsFromModel(model),

  toModel: (state) => ({
    type: Step.SEPARATE_LABELS,
    customTitle: state.customTitle,
  }),

  valid: (state) => isSeparateLabelsStepValid(state).valid,

  stepDeleted: (state) => state,
});

export { type SeparateLabelsState } from "@redotech/redo-model/return-flow-step-valid";
